import React, { useState } from 'react';
import { useTheme } from 'ThemeContext';
import { FormattedMessage } from 'react-intl';
import {
  Bar,
  Box,
  Button,
  CalendarContainer,
  Event,
  EventsContainer,
  HeadTitle,
  ImageBox,
  Image,
  Wrapper,
  DateBox,
  Day,
  Month,
  EventTitle,
  Text
} from './WidgetEvents.style';
import WidgetCalendar from '../WidgetCalendar';
import Title from 'components/Title';
import moment from 'moment';

function WidgetEvents({
  todayDate,
  data = [],
  title = '',
  titleColor = undefined,
  titleBackground = undefined,
  linkBackground = undefined,
  linkColor = undefined,
  linkText = '',
  slug = ''
}) {
  const theme = useTheme();

  const monthName = [
    'stycznia',
    'lutego',
    'marca',
    'kwietnia',
    'maja',
    'czerwca',
    'lipca',
    'sierpnia',
    'września',
    'października',
    'listopada',
    'grudnia'
  ];

  return (
    <Wrapper>
      <EventsContainer theme={theme.widgetEvents.eventsContainer}>
        <Title
          title={title}
          titleColor={titleColor}
          titleBackground={titleBackground}
          linkBackground={linkBackground}
          linkColor={linkColor}
          linkText={linkText}
          slug={slug}
        />
        <Box theme={theme.widgetEvents.box}>
          {data &&
            data.map((item, index) => (
              <Event
                key={index}
                to={item.slug}
                theme={theme.widgetEvents.event}
              >
                <ImageBox theme={theme.widgetEvents.imageBox}>
                  <Image src={item.image} />
                  <DateBox theme={theme.widgetEvents.dateBox}>
                    <Day theme={theme.widgetEvents.day}>
                      {moment(item.date).date()}
                    </Day>
                    <Month theme={theme.widgetEvents.month}>
                      {monthName[moment(item.date).month()]}
                    </Month>
                  </DateBox>
                </ImageBox>
                <EventTitle theme={theme.widgetEvents.title}>
                  {item.title}
                </EventTitle>
                <Text theme={theme.widgetEvents.text}>{item.text}</Text>
              </Event>
            ))}
        </Box>
      </EventsContainer>
      <CalendarContainer>
        <WidgetCalendar
          data={data}
          todayDate={todayDate}
          slug={slug}
          showEvents={false}
        />
      </CalendarContainer>
    </Wrapper>
  );
}

export default WidgetEvents;
